const buttons = document.querySelectorAll("[data-buttons]")
const searchForm = document.querySelector("[data-mobile-search-form]")
const mainHeader = document.querySelector("[data-main-header]")
const mobileNavigation = document.querySelector("[data-mobile-navigation]")
const shoppingCartPanel = document.querySelector("[data-shopping-cart-panel")
const backdrops = document.querySelectorAll(".mobile-nav-backdrop")
const captcha = document.querySelector(".shopify-challenge__container")
const shoppingCartCounts = document.querySelectorAll("[data-shopping-cart")
const productLink = document.querySelector("[data-main-nav-product]")
const headerSlide = document.querySelectorAll("[data-mouseleave-slide-out]")
const mainLinks = document.querySelectorAll("[data-main-nav-link]")
const mainNavMenus = document.querySelectorAll("[data-main-nav-link-menu]")
const mobileNavMenus = document.querySelectorAll("[data-mobile-nav-link-menu]")
const mobileNavMenuBtns = document.querySelectorAll("[data-mobile-nav-link-menu-btn]")

if(captcha)
    captcha.setAttribute("data-main-section", "")
var screenWidth = window.innerWidth
let mainSection = document.querySelector("[data-main-section]")
let isScrolled

createObserver()

if(window.scrollY >= 165) {
    isScrolled = true
} else {
    isScrolled = false
}
scrolledHeaderCheck()

window.addEventListener("resize", () => {
    var shownItems = document.querySelectorAll(".show")
    var openItems = document.querySelectorAll(".open")
    shownItems.forEach(item => {
        item.classList.remove("show")
        item.classList.add("hidden")
    })
    openItems.forEach(item => {
        item.classList.remove("open")
        item.classList.add("hidden")
    })
    document.body.classList.remove("no-scroll")
    screenWidth = window.innerWidth
})

mainNavMenus.forEach(menu => {
    menu.addEventListener("transitionend", (event) => {
        setTimeout(() => {
            event.target.classList.add("hidden")
            event.target.ariaHidden = "true"
        }, 100);
    })
})

mainLinks.forEach(link => {
    link.addEventListener("mouseover", (event) => {
        if(event.target.getAttribute("data-sublinks") != 0) {
            event.target.nextElementSibling.classList.remove("hidden")
            event.target.nextElementSibling.ariaHidden = "false"
        }
    })
})

mobileNavMenuBtns.forEach(btn => {
    btn.addEventListener("click", (event) => {
        var temp = document.querySelector(".mobile-nav-products-btn.expanded")
        var nextElement = event.target.nextElementSibling
        console.log(event);

        if(temp && temp != event.target) {
            temp.classList.remove("expanded")
            setTimeout(() => {
                if(nextElement && nextElement.classList.contains("hidden"))
                nextElement.classList.remove("hidden")
        
                setTimeout(() => {
                    event.target.classList.toggle("expanded")
                    if(nextElement.children.length > 2 && !nextElement.classList.contains("auto-overflow"))
                        nextElement.classList.add("auto-overflow")
                }, 100)
            }, 500);
        } else {
            if(nextElement && nextElement.classList.contains("hidden"))
                nextElement.classList.remove("hidden")
            
            setTimeout(() => {
                event.target.classList.toggle("expanded")
                if(nextElement.children.length > 2 && !nextElement.classList.contains("auto-overflow"))
                    nextElement.classList.add("auto-overflow")
            }, 100)
        }

    })
})

mobileNavMenus.forEach(menu => {
    menu.addEventListener("transitionend", (event) => {
        if(event.target.getBoundingClientRect().height === 0)
            event.target.classList.add("hidden")
    })
})

productLink.addEventListener("focusin", (event) => {
    if(!headerSlide[1].classList.contains("open")) {
        headerSlide[1].classList.remove("hidden")
        setTimeout(() => {
            headerSlide[1].classList.add("open")
        }, 100)
    }
})

$(document).on('keydown', function(event) {
    if(event.key === "Escape") {
        if(headerSlide[1].classList.contains("open")) {
            headerSlide[1].classList.remove("open")
            setTimeout(() => {
                headerSlide[1].classList.add("hidden")
            }, 500)
        }
    }
});

productLink.addEventListener("mouseover", (event) => {
    if(!headerSlide[1].classList.contains("open")) {
        headerSlide[1].classList.remove("hidden")
        setTimeout(() => {
            headerSlide[1].classList.add("open")
        }, 100)
    }
})

var mouseInArr = [false, false]
headerSlide.forEach(element => {
    element.addEventListener("mouseenter", (event) => {
        var elementName = element.getAttribute("data-mouseleave-slide-out")
        if(elementName === "header") {
            mouseInArr[0] = true
        } else if(elementName === "slide-out") {
            mouseInArr[1] = true
        }
    })
})
headerSlide.forEach(element => {
    element.addEventListener("mouseleave", (event) => {
        var elementName = element.getAttribute("data-mouseleave-slide-out")
        if(elementName === "header") {
            mouseInArr[0] = false
        } else if(elementName === "slide-out") {
            mouseInArr[1] = false
        }

        if(isInside() === false) {
            headerSlide[1].classList.remove("open")
            setTimeout(() => {
                headerSlide[1].classList.add("hidden")
            }, 500)
        }
    })
})

function isInside() {
    var temp
    mouseInArr.forEach(value => {
        if(value === true || temp === true) {
            temp = true
        } else if(value === false && temp != true) {
            temp = false
        }
    })
    return temp
}

backdrops.forEach(backdrop => {
    backdrop.addEventListener("click", () => {
        let temp = document.body
        var productSlideOut = document.querySelector("[data-product-slide-out='mobile']")
        mobileNavMenuBtns.forEach(navMenuBtn => {
            if(navMenuBtn.classList.contains("expanded")) {
                navMenuBtn.classList.remove("expanded")
                setTimeout(() => {
                    navMenuBtn.nextElementSibling.classList.add("hidden")
                }, 500)
            } 
        })
        if(screenWidth > 825)
            backdrops[1].classList.toggle("show")
        else
            backdrops[0].classList.toggle("show")
        temp.classList.remove("no-scroll")
        if(shoppingCartPanel.classList.contains("open")) {
            shoppingCartPanel.classList.toggle("open")
            setTimeout(() => {
                shoppingCartPanel.classList.toggle("hidden")
            }, 500)
        } else if(mobileNavigation.classList.contains("open")) {
            mobileNavigation.classList.toggle("open")
            document.querySelector("[data-buttons='shopping-cart'].shopping-cart-btn-mobile").classList.remove("hidden")
            setTimeout(() => {
                mobileNavigation.classList.toggle("hidden")
            }, 500)
        }

        if(productSlideOut.classList.contains("open")) {
            setTimeout(() => {
                productSlideOut.classList.remove("open")
                productSlideOut.classList.add("hidden")
            }, 500)
        }
    })
})

buttons.forEach(button => {
    button.addEventListener("click", () => {
        let btnName = button.getAttribute("data-buttons")
        let temp = document.body
        if(btnName === "shopping-cart") {
            shoppingCartPanel.classList.toggle("hidden")
            setTimeout(() => {
                shoppingCartPanel.classList.toggle("open")
                if(screenWidth > 825)
                    backdrops[1].classList.toggle("show")
                else
                    backdrops[0].classList.toggle("show")
            }, 100)
            setTimeout(() => {
                temp.classList.add("no-scroll")
            }, 500)
        } else if(btnName === "mobile-nav") {
            mobileNavigation.classList.toggle("hidden")
            setTimeout(() => {
                mobileNavigation.classList.toggle("open")
                document.querySelector("[data-buttons='shopping-cart'].shopping-cart-btn-mobile").classList.add("hidden")
                if(screenWidth > 825)
                    backdrops[1].classList.toggle("show")
                else
                    backdrops[0].classList.toggle("show")
            }, 100)
            setTimeout(() => {
                temp.classList.add("no-scroll")
            }, 500)
        } else if(btnName === "nav-close") {
            if(screenWidth > 825)
                    backdrops[1].classList.toggle("show")
                else
                    backdrops[0].classList.toggle("show")
            mobileNavMenuBtns.forEach(navMenuBtn => {
                if(navMenuBtn.classList.contains("expanded")) {
                    navMenuBtn.classList.remove("expanded")
                    setTimeout(() => {
                        navMenuBtn.nextElementSibling.classList.add("hidden")
                    }, 500)
                } 
            })
            temp.classList.remove("no-scroll")
            mobileNavigation.classList.toggle("open")
            document.querySelector("[data-buttons='shopping-cart'].shopping-cart-btn-mobile").classList.remove("hidden")
            setTimeout(() => {
                mobileNavigation.classList.toggle("hidden")
            }, 500)
        } else if(btnName === "cart-close") {
            if(screenWidth > 825)
                    backdrops[1].classList.toggle("show")
                else
                    backdrops[0].classList.toggle("show")
            temp.classList.remove("no-scroll")
            shoppingCartPanel.classList.toggle("open")
            setTimeout(() => {
                shoppingCartPanel.classList.toggle("hidden")
            }, 500)
        } else if(btnName === "search") {
            searchForm.classList.toggle("visible")
        } else if(btnName === "close-search") {
            searchForm.classList.remove("visible")
        } else if(btnName === "mobile-nav-product") {
            var productSlideOut = document.querySelector("[data-product-slide-out='mobile']")
            productSlideOut.classList.remove("hidden")
            setTimeout(() => {
                productSlideOut.classList.add("open")
            }, 100)
        } else if(btnName === "product-cat-close") {
            var productSlideOut = document.querySelector("[data-product-slide-out='mobile']")
            productSlideOut.classList.remove("open")
            setTimeout(() => {
                productSlideOut.classList.add("hidden")
            }, 500);
        }
    })
})

function createObserver() {
    let observer;

    let options = {
        root: null,
        rootMargin: "0px 0px -92% 0px",
        threshold: 0,
    }

    observer = new IntersectionObserver(handleIntersection, options)
    observer.observe(mainSection)
}

function scrolledHeaderCheck() {
    if(isScrolled) {
        if(screenWidth > 825 && screenWidth < 1200) {
            isScrolled = true
            mainHeader.children[0].children[0].classList.add("scrolled")
        } else if(screenWidth > 1200) {
            isScrolled = true
            mainHeader.children[0].children[0].classList.add("scrolled")
            mainHeader.children[0].children[0].classList.remove("margin")
        } else {
            isScrolled = true
            mainHeader.children[1].classList.add("scrolled")
        }
    } else {
        if(screenWidth > 825 && screenWidth < 1200) {
            isScrolled = true
            mainHeader.children[0].children[0].classList.remove("scrolled")
        } else if(screenWidth > 1200) {
            isScrolled = true
            mainHeader.children[0].children[0].classList.remove("scrolled")
            mainHeader.children[0].children[0].classList.add("margin")
        } else {
            isScrolled = true
            mainHeader.children[1].classList.remove("scrolled")
        }
    }

}

function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        
        if(entry.isIntersecting && entry.boundingClientRect.y >= 0) {
            if(screenWidth > 825 && screenWidth < 1200) {
                isScrolled = true
                mainHeader.children[0].children[0].classList.add("scrolled")
            } else if(screenWidth > 1200) {
                isScrolled = true
                mainHeader.children[0].children[0].classList.add("scrolled")
                mainHeader.children[0].children[0].classList.remove("margin")
            } else {
                isScrolled = true
                mainHeader.children[1].classList.add("scrolled")
            }
        } else if(!entry.isIntersecting && entry.boundingClientRect.y >= 0) {
            if(screenWidth > 825 && screenWidth < 1200) {
                isScrolled = true
                mainHeader.children[0].children[0].classList.remove("scrolled")
            } else if(screenWidth > 1200) {
                isScrolled = true
                mainHeader.children[0].children[0].classList.remove("scrolled")
                mainHeader.children[0].children[0].classList.add("margin")
            } else {
                isScrolled = true
                mainHeader.children[1].classList.remove("scrolled")
            }

        }
    })
}